// Mock data for Medily clone

export const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_medily-pro/artifacts/b93lcxd2_Full%20logo%20w.o%20white%20background.png";

export const HERO_ILLUSTRATION = "https://customer-assets.emergentagent.com/job_medily-pro/artifacts/k9vb3cu9_Test%201.webp";

// Painterly pastel medical illustrations (client-provided assets)
export const IMG_DOCTOR_PATIENT = "https://customer-assets.emergentagent.com/job_medily-pro/artifacts/k9vb3cu9_Test%201.webp";
export const IMG_STUDENTS_HEART = "https://customer-assets.emergentagent.com/job_medily-pro/artifacts/stcnjyz5_Test%202.webp";
export const IMG_TRIPTYCH = "https://customer-assets.emergentagent.com/job_medily-pro/artifacts/y3y6setc_Test%203.png";

export const UNIVERSITIES = [
  { name: "University of Oxford", label: "OXFORD" },
  { name: "University of Cambridge", label: "CAMBRIDGE" },
  { name: "UCL", label: "UCL" },
  { name: "Imperial College London", label: "Imperial" },
  { name: "King's College London", label: "KING'S" },
  { name: "University of Bristol", label: "BRISTOL" },
  { name: "University of Edinburgh", label: "EDINBURGH" },
  { name: "University of Manchester", label: "MANCHESTER" },
];

export const FEATURES = [
  {
    number: "1",
    title: "University Specific\nMMI Interviewer",
    body: "Practice unlimited MMI stations with our AI interviewer trained on real medical school formats.",
    bullets: [
      "University specific scenarios",
      "Real-time follow-up questions",
      "Instant, detailed feedback",
    ],
    imageSide: "left",
  },
  {
    number: "2",
    title: "High Quality\nMMI Resources",
    body: "Access concise, expert-written resources made by doctors and admission experts.",
    bullets: [
      "Topic summaries & guides",
      "Example answers & frameworks",
      "Ethics, NHS values & more",
    ],
    imageSide: "right",
  },
  {
    number: "3",
    title: "Meet Maya —\nYour AI Interviewer",
    body: "Talk with Maya, our voice-first AI examiner who runs realistic MMI stations tailored to your target medical school.",
    bullets: [
      "Voice-first conversations",
      "Adaptive follow-up probing",
      "Personalised, structured feedback",
    ],
    imageSide: "left",
  },
];

export const STATS = [
  { value: "12,000+", label: "Students prepared" },
  { value: "98%", label: "Would recommend" },
  { value: "40+", label: "UK medical schools" },
  { value: "3.2x", label: "Higher offer rate" },
];

export const TESTIMONIALS = [
  { name: "Sofia R.", school: "Offer: King’s College London", avatar: "https://i.pravatar.cc/100?img=47", body: "Maya’s follow-up questions felt exactly like my real MMI. I walked in on interview day feeling calm and ready." },
  { name: "Aarav P.", school: "Offer: Imperial College", avatar: "https://i.pravatar.cc/100?img=52", body: "The university-specific stations were a game-changer. Nothing else on the market comes close." },
  { name: "Elena K.", school: "Offer: Oxford", avatar: "https://i.pravatar.cc/100?img=25", body: "The ethics guide plus Maya practice took my scores from average to consistently 8/10." },
];

export const FAQS = [
  { q: "Is Medily specific to my target medical school?", a: "Yes. Maya adapts stations, scenarios and marking criteria to the university you’re applying to — including Oxford, Cambridge, UCL, Imperial, King’s and 40+ others." },
  { q: "How does Maya, the AI interviewer, work?", a: "Maya is a voice-first AI trained on real MMI formats. She asks the initial question, probes with follow-ups, then gives structured, evidence-based feedback within seconds." },
  { q: "Do I get feedback after every practice?", a: "Every session ends with a detailed rubric-style breakdown — communication, structure, empathy, ethics reasoning, and clinical logic." },
  { q: "Can I book a mock with a real examiner?", a: "Yes. You can book expert-led online or in-person mock circuits alongside your AI practice." },
  { q: "Is there a free trial?", a: "You can create an account and preview several stations plus the guide library before committing to a plan." },
];

export const PRICING = [
  { name: "Starter", price: "£0", period: "forever", features: ["Preview Maya stations", "Sample resources", "Community access"], cta: "Get Started", featured: false },
  { name: "Pro", price: "£49", period: "/ month", features: ["Unlimited Maya AI practice", "Full resource library", "Progress analytics", "University-specific packs"], cta: "Start Pro", featured: true },
  { name: "Ultimate", price: "£149", period: "/ month", features: ["Everything in Pro", "2 examiner-led mocks", "1:1 admissions coaching", "Priority support"], cta: "Go Ultimate", featured: false },
];

export const USER = { name: "Alex", avatar: "https://i.pravatar.cc/100?img=15" };

export const DASHBOARD_STATS = [
  { label: "Mock Interviews", value: "3", sub: "Completed", tone: "blue" },
  { label: "Practice Questions", value: "247", sub: "Answered", tone: "green" },
  { label: "Study Streak", value: "12", sub: "Days", tone: "amber" },
  { label: "Average Score", value: "78%", sub: "Improvement", tone: "purple" },
];

export const RECOMMENDED = [
  { title: "Cardiovascular", sub: "MMI Station", tag: "Practice Now" },
  { title: "Ethics", sub: "MMI Station", tag: "Practice Now" },
  { title: "Communication", sub: "MMI Station", tag: "Practice Now" },
  { title: "Data Interpretation", sub: "MMI Station", tag: "Practice Now" },
];

export const STUDY_RESOURCES = [
  { id: "mmi-guide", title: "MMI Interview Guide", desc: "Comprehensive guide to MMI success.", category: "Guides", slug: "mmi-interview-guide" },
  { id: "communication", title: "Communication Skills", desc: "Master patient communication.", category: "Guides", slug: "communication" },
  { id: "ethics", title: "Ethics in Medicine", desc: "Key ethical principles and scenarios.", category: "Guides", slug: "ethics" },
  { id: "data-interp", title: "Data Interpretation", desc: "Practice data-handling questions.", category: "Worksheets", slug: "data-interpretation" },
  { id: "anatomy", title: "Anatomy Refresher", desc: "Essential anatomy revision notes.", category: "Videos", slug: "anatomy" },
  { id: "confidentiality", title: "Confidentiality", desc: "Understand when confidentiality can be broken.", category: "Articles", slug: "confidentiality" },
  { id: "consent", title: "Informed Consent", desc: "Elements of valid consent in practice.", category: "Articles", slug: "consent" },
  { id: "nhs-values", title: "NHS Values", desc: "The 6Cs and their application.", category: "Guides", slug: "nhs-values" },
];

export const CASE_STUDIES = [
  { title: "From Rejection to Offer", desc: "How persistence and feedback helped me get in.", category: "Interview Experiences" },
  { title: "Balancing Academics & Preparation", desc: "Tips for managing time effectively.", category: "Tips & Strategies" },
  { title: "MMI Strategies That Made the Difference", desc: "Key strategies that helped me stand out.", category: "Successful Applicants" },
  { title: "My Journey to Medical School", desc: "A personal story of dedication and passion.", category: "Interview Experiences" },
];

export const PROGRESS_DATA = {
  overall: 65,
  streak: 12,
  weekly: [
    { day: "Mon", value: 40 },
    { day: "Tue", value: 65 },
    { day: "Wed", value: 55 },
    { day: "Thu", value: 80 },
    { day: "Fri", value: 70 },
    { day: "Sat", value: 90 },
    { day: "Sun", value: 78 },
  ],
  skills: [
    { name: "Communication", value: 82 },
    { name: "Ethics", value: 71 },
    { name: "Data Interpretation", value: 64 },
    { name: "Empathy", value: 88 },
    { name: "Clinical Reasoning", value: 59 },
  ],
  recent: [
    { title: "Ethics MMI Station", score: 82, date: "Today" },
    { title: "Cardiovascular Station", score: 74, date: "Yesterday" },
    { title: "Communication Practice", score: 88, date: "2 days ago" },
    { title: "Data Interpretation", score: 66, date: "3 days ago" },
  ],
};

export const CONFIDENTIALITY_ARTICLE = {
  crumbs: ["Study Resources", "Medical Ethics Guide", "Confidentiality"],
  title: "Confidentiality",
  subtitle: "Understanding the importance of confidentiality and when it can be broken in medical practice.",
  progress: 75,
  lastReviewed: "2 days ago",
  overview:
    "Confidentiality is a fundamental ethical and legal obligation in healthcare. It means not sharing information about a patient with others without their permission. It builds trust, encourages patients to be honest, and ensures their privacy and dignity are respected.",
  takeaways: [
    { icon: "shield", title: "Respect & Trust", body: "Confidentiality builds trust and is essential for effective care." },
    { icon: "user", title: "Patient Rights", body: "Patients have a right to privacy and control over their information." },
    { icon: "scale", title: "Legal Duty", body: "You have a legal and professional duty to keep information confidential." },
    { icon: "lock", title: "Exceptions Exist", body: "Confidentiality can be broken in certain situations to prevent harm or by law." },
  ],
  breakList: [
    "There is a risk of serious harm to the patient or others.",
    "There is a legal requirement (e.g. court order, notifiable diseases).",
    "The patient lacks capacity and disclosure is in their best interests.",
    "The patient has given informed consent.",
    "The information is already in the public domain.",
  ],
  keyPrinciple: "Always share the minimum necessary information with the right person, for the right reason, and in the right way.",
  realLife: {
    text: "A 28-year-old patient tells you they are experiencing domestic abuse but asks you not to tell anyone. They have visible injuries.",
    consider: ["Risk of harm", "Patient's wishes", "Safeguarding responsibilities", "Information sharing principles"],
  },
};
